import { Component, EventEmitter, Output } from '@angular/core';
import { Constants } from '@base/src/app/models/constants';
import { DialogEvent } from '@base/src/app/models/dialog-event.model';
import { QRIcon } from '@base/src/app/models/qr-icon.model';

@Component({
  selector: 'app-rendition-movement-generate-automatic',
  templateUrl: './rendition-movement-generate-automatic.component.html',
  styleUrls: ['./rendition-movement-generate-automatic.component.scss'],
})
export class RenditionMovementGenerateAutomaticComponent {
  @Output() dialogChange: EventEmitter<DialogEvent> =
    new EventEmitter<DialogEvent>();
  value: string | undefined;

  readonly ICON_WARNING = Constants.ICONS.WARNING;
  readonly ICON_COLOR_WHITE = QRIcon.COLOR_WHITE;
}
